import { useSyncExternalStore } from 'react';

// src/primitives/useFullscreenPortal.ts
function subscribe(notify) {
  document.addEventListener("fullscreenchange", notify);
  return () => document.removeEventListener("fullscreenchange", notify);
}
var current = () => document.fullscreenElement ?? void 0;
var server = () => void 0;
function useFullscreenPortal() {
  return useSyncExternalStore(subscribe, current, server);
}

export { useFullscreenPortal };
//# sourceMappingURL=chunk-MBTLYAMU.js.map
//# sourceMappingURL=chunk-MBTLYAMU.js.map